/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData
 */
export interface FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData
     */
    Sku: string;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData
     */
    CanBePurchased: boolean;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData
     */
    ClientMetadata?: string | null;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData interface.
 */
export function instanceOfFxIdApplicationStoreCheckBuyProductsCheckBuyProductsData(value: object): value is FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData {
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    if (!('CanBePurchased' in value) || value['CanBePurchased'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSON(json: any): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData {
    if (json == null) {
        return json;
    }
    return {
        
        'Sku': json['Sku'],
        'CanBePurchased': json['CanBePurchased'],
        'ClientMetadata': json['ClientMetadata'] == null ? undefined : json['ClientMetadata'],
    };
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSON(json: any): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSONTyped(value?: FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Sku': value['Sku'],
        'CanBePurchased': value['CanBePurchased'],
        'ClientMetadata': value['ClientMetadata'],
    };
}

